import { client } from "../../client";

/**
 * Requests to change the area.
 * @param {string} area the area name
 */
export const sendAreaChange = (area: string) => {
  client.sender.sendServer(`MC#${area}#${client.charID}#%`);
};
